<div class="filter-buttons-container">
  <!-- Price Changed Filter -->
  <ion-button
    data-cy="price-changed-filter-button"
    [class]="
      activeStates[FilterType.showAllPriceChange]
        ? 'usf-fill-green-button'
        : 'usf-outline-green-button'
    "
    (click)="onPriceChangedClick()"
  >
    {{ 'i18n.lists.pmeList.showAllPriceChanged' | translate }}
    <ion-icon
      *ngIf="activeStates[FilterType.showAllPriceChange]"
      name="close-outline"
      slot="end"
    ></ion-icon>
  </ion-button>

  <!-- Not in Optimized Range Filter -->
  <ion-button
    data-cy="not-in-optimized-range-filter-button"
    [class]="
      activeStates[FilterType.notInOptimizedRange]
        ? 'usf-fill-green-button'
        : 'usf-outline-green-button'
    "
    (click)="onNotInOptimizedRangeClick()"
  >
    {{ 'i18n.lists.pmeList.notInOptimizedRange' | translate }}
    <ion-icon
      *ngIf="activeStates[FilterType.notInOptimizedRange]"
      name="close-outline"
      slot="end"
    ></ion-icon>
  </ion-button>

  <!-- Market Changed Filter -->
  <ion-button
    data-cy="market-changed-filter-button"
    [class]="
      activeStates[FilterType.showAllMarketChange]
        ? 'usf-fill-green-button'
        : 'usf-outline-green-button'
    "
    (click)="onMarketChangedClick()"
  >
    {{ 'i18n.lists.pmeList.showAllMarketChanged' | translate }}
    <ion-icon
      *ngIf="activeStates[FilterType.showAllMarketChange]"
      name="close-outline"
      slot="end"
    ></ion-icon>
  </ion-button>
</div>
